import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

import { authenticatedRoute } from "../_authenticated.js";

const documentsSearchSchema = z.object({
  mode: z.enum(["vault", "working", "agreements"]).optional().catch(undefined),
  workspaceId: z.string().uuid().optional().catch(undefined),
  create: z.coerce.boolean().optional().catch(undefined),
  /** Jump-to… / ⌘K deep-link into a vault folder. */
  folderId: z.string().uuid().optional().catch(undefined),
  /** Jump-to… / ⌘K prefill for the vault title/filename search box. */
  q: z.string().max(200).optional().catch(undefined),
  /** After promote: open Send for signature on this Vault document. */
  sendDocId: z.string().uuid().optional().catch(undefined),
  sendDocTitle: z.string().max(500).optional().catch(undefined),
});

export const documentsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/documents",
  validateSearch: (search: Record<string, unknown>) => documentsSearchSchema.parse(search),
  component: lazyRouteComponent(
    () => import("@l30/web-documents/pages/documents.page"),
    "VaultPage",
  ),
});
